import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The Stripe connector can link charges, customers, invoices, prices, products, subscriptions, and balance transactions to PostHog. `}</p>
    <h2 {...{
      "id": "creating-a-stripe-api-key"
    }}>{`Creating a Stripe API key`}</h2>
    <p>{`You need a Stripe API key to create a connector. Head to your Stripe dashboard > `}<strong parentName="p">{`Developers`}</strong>{` > `}<strong parentName="p">{`API keys`}</strong>{`, under `}<strong parentName="p">{`Restricted keys`}</strong>{`, click `}<a parentName="p" {...{
        "href": "https://dashboard.stripe.com/apikeys/create"
      }}>{`+ Create a restricted key`}</a>{`.`}</p>
    <p>{`You need to give your API key the following `}<strong parentName="p">{`Read`}</strong>{` permissions:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Resource Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required Read Permissions`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Core`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Balance transaction sources, Charges, Customer, Product, Disputes, Payouts`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Billing`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Invoice, Price, Subscription, Credit notes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Connected`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`All resources`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "adding-a-data-source"
    }}>{`Adding a data source`}</h2>
    <ol>
      <li parentName="ol">{`In PostHog, go to the `}<a parentName="li" {...{
          "href": "https://us.posthog.com/pipeline/sources"
        }}>{`Data pipeline page`}</a>{` select the `}<strong parentName="li">{`Sources`}</strong>{` tab.`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`+ New source`}</strong>{` button and select Stripe by clicking the `}<strong parentName="li">{`Link`}</strong>{` button.`}</li>
      <li parentName="ol">{`In Stripe, get your Account ID by going to `}<strong parentName="li">{`Settings`}</strong>{` > `}<strong parentName="li">{`Business`}</strong>{`, selecting the `}<a parentName="li" {...{
          "href": "https://dashboard.stripe.com/settings/account"
        }}>{`Account details`}</a>{` tab, and clicking your `}<strong parentName="li">{`Account ID`}</strong>{` or pressing `}<inlineCode parentName="li">{`⌘`}</inlineCode>{` + `}<inlineCode parentName="li">{`I`}</inlineCode>{` to copy your ID.`}</li>
      <li parentName="ol">{`Get your API key from the `}<a parentName="li" {...{
          "href": "#creating-a-stripe-api-key"
        }}>{`previous section`}</a></li>
      <li parentName="ol"><em parentName="li">{`Optional:`}</em>{` Add a prefix to your table names`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Next`}</strong></li>
    </ol>
    <blockquote>
      <p parentName="blockquote">{`For Stripe tables, incremental syncs will only sync new records and not update existing records. This is a limitation of the Stripe API in which it's not possible to query for updated data. `}</p>
    </blockquote>
    <p>{`The data warehouse then starts syncing your Stripe data. You can see details and progress in the `}<a parentName="p" {...{
        "href": "https://us.posthog.com/pipeline/sources"
      }}>{`data pipeline sources tab`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      